import axiosInstance from "../axiosApi";
import { ROUTE_NAME, routeTo } from './routes';
import {objectToFormData} from "../function/objectToFormData";

export default {
    // called when the user attempts to log in
    getCustomers: async (filters) => {
        return await axiosInstance.get(routeTo(ROUTE_NAME.ACCOUNT.GET_CUSTOMERS, filters)).then(response => {
            return response
        }).catch(error => error)
    },
    getCustomerDetail: async ({id}) => {
        return await axiosInstance.get(routeTo(ROUTE_NAME.ACCOUNT.GET_CUSTOMER_DETAIL, {}, {id})).then(response => {
            return response
        }).catch(error => error)
    },
    updateCustomer: async ({data, id}) => {
        return await axiosInstance.patch(routeTo(ROUTE_NAME.ACCOUNT.UPDATE_CUSTOMER, {}, {id}), objectToFormData(data), {headers: { 'content-type': 'multipart/form-data' }}).then(response => {
            return response
        }).catch(error => error)
    },
};
